{
  "id": 7,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 11,
  "kinds": 5,
  "goals": [
    { "type": "collect", "kind": "cupcake", "count": 30 },
    { "type": "collect", "kind": "latte", "count": 30 }
  ],
  "stars": [4510, 6050],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.942, "movesLeft": 3.4, "closeLosses": 0.023, "target": 0.92 }
}
